import React from "react";
import {HashRouter, Redirect, Route, Switch} from "react-router-dom";

// components
import Layout from "./Layout/Layout";

// pages
import Error from "../pages/error/Error";
import Login from "../pages/login/Login";
import {connect} from "react-redux";
import ResetPassword from "../pages/resetPassword/ResetPassword";

import TagManager from 'react-gtm-module';

function App(props) {
    // global
    const isAuthenticated = props.isAuthenticated

    if(window.dataLayer) {
        window.dataLayer.push({
            event: 'pageview'
        });
    }

    if (props.cookiesAccepted) {
        const tagManagerArgs = {
            gtmId: 'GTM-KB4MSMK',
            events: {
                sendUserInfo: 'userInfo'
            }
        }

        TagManager.initialize(tagManagerArgs)
    }

    return (
        <HashRouter>
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/app/dashboard"/>}/>
                <Route
                    exact
                    path="/app"
                    render={() => <Redirect to="/app/dashboard"/>}
                />
                <PrivateRoute path="/app" component={Layout}/>
                <PublicRoute path="/login" component={Login}/>
                <PublicRoute path="/resetPassword/:token" component={ResetPassword} />
                <Route component={Error}/>
            </Switch>
        </HashRouter>
    );

    // #######################################################################

    function PrivateRoute({component, ...rest}) {
        return (
            <Route
                {...rest}
                render={props => {
                    return (isAuthenticated || props.location.pathname.indexOf('resetPassword')) ? (
                        React.createElement(component, props)
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {
                                    from: props.location,
                                },
                            }}
                        />
                    )
                }
                }
            />
        );
    }

    function PublicRoute({component, ...rest}) {
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        <Redirect
                            to={{
                                pathname: "/",
                            }}
                        />
                    ) : (
                        React.createElement(component, props)
                    )
                }
            />
        );
    }
}


const mapStateToProps = ({user}) => {
    return user;
}

export default connect(mapStateToProps)(App);